export default __webpack_public_path__ + "static/blobfiled-3dbaa5d98be754406d0927638cc6bcd9.png";